import * as Yup from 'yup';

export const contentStepSchema = Yup.object({
    title: Yup.string()
        .required('Tytuł jest wymagany')
        .default(""),

    summary: Yup.string()
        .required('Streszczenie jest wymagane')
        .default(""),

    content: Yup.string()
        .default("")
        .required('Treść artykułu jest wymagana'),

    // Tagi są opcjonalne – można zapisać artykuł bez żadnego tagu
    tags: Yup.array()
        .of(Yup.string().required())
        .default([])
        .max(10, 'Możesz dodać maksymalnie 10 tagów'),
});

